module.exports = require('./lib/components/EllipsisText');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-ellipsis-text/index.js
 ** module id = 3377
 ** module chunks = 0
 **/